import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconDimensions = ({
  color = colorGray,
  width = '21',
  height = '21',
  className = '',
  idPrefix = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 21"
    className={className}
    fill="none"
  >
    <g clipPath={`url(#IconDimensionsClipPath${idPrefix})`}>
      <path
        d="M8.50244 0.278687L2.25244 0.278687C1.90712 0.278687 1.62744 0.558367 1.62744 0.903687L1.62744 19.6537C1.62744 19.8193 1.69307 19.9787 1.81025 20.0959C1.92744 20.2131 2.08681 20.2787 2.25243 20.2787H8.50243C8.66806 20.2787 8.82743 20.2131 8.94461 20.0959C9.0618 19.9787 9.12742 19.8193 9.12742 19.6537V0.903687C9.12742 0.738063 9.0618 0.578687 8.94461 0.461507C8.82743 0.344319 8.66805 0.278695 8.50243 0.278695L8.50244 0.278687ZM7.87744 19.0287H2.87744V17.1537H6.00244V15.9037H2.87744V14.0287H4.75244V12.7787H2.87744V10.9037H6.00244V9.65369H2.87744V7.77869H4.75244V6.52869H2.87744L2.87744 4.65369H6.00244V3.40369L2.87744 3.40369V1.52869L7.87744 1.52869L7.87744 19.0287Z"
        fill={color}
      />
      <path
        d="M16.7524 18.1469V2.40926L18.8086 4.46546L19.6898 3.58422L16.5648 0.459223C16.3211 0.217043 15.9273 0.217043 15.6836 0.459223L12.5586 3.58422L13.4398 4.46546L15.5022 2.40926V18.1469L13.446 16.0907L12.5648 16.9719L15.6898 20.0969C15.9336 20.3391 16.3273 20.3391 16.571 20.0969L19.696 16.9719L18.8148 16.0907L16.7524 18.1469Z"
        fill={color}
      />
    </g>

    <defs>
      <clipPath id={`IconDimensionsClipPath${idPrefix}`}>
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.752441 0.278076)"
        />
      </clipPath>
    </defs>
  </svg>
);

IconDimensions.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idPrefix: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconDimensions;
